import { NO_PORTFOLIOS, LOADING, SUCCESS_PORTFOLIOS, SELECT_PORTFOLIO, UPDATE_SELECTED_PORTFOLIO, SUCCESS_DATA, SET_DATE_RANGE_LOADING } from './PortfolioActions';

const INITIAL_STATE = {
  noPortfolios: false,
  isLoading: false,
  loaded: false,
  dateRangeLoading: false,
  settings: {
    dashboards: [],
  },
  portfolios: [],
  stats: {},
  trends: {},
  comparison: {},
  selectedPortfolio: {}
};

const PortfolioReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NO_PORTFOLIOS: {
      return { ...state, noPortfolios: true, loaded: true, selectedPortfolio:{}, portfolios: [], issue: '' };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS_PORTFOLIOS: {
      return { ...state, isLoading: false, loaded: true, portfolios: action.portfolios };
    }
    case SELECT_PORTFOLIO: {
      const keepData = !(state.selectedPortfolio && state.selectedPortfolio._id) &&
        !!action.selected && action.selected._id === state.dataPortfolioId;
      return {
        ...state,
        isLoading: false,
        noPortfolios: false,
        selectedPortfolio: action.selected,
        viewId: action.viewId,
        stats: keepData ? state.stats : {},
        trends: keepData ? state.trends : {}
      };
    }
    case UPDATE_SELECTED_PORTFOLIO: {
      return { ...state, selectedPortfolio: action.selected };
    }
    case SUCCESS_DATA: {
      return {
        ...state,
        isLoading: false,
        dataPortfolioId: action.data.portfolioId,
        stats: action.data.stats,
        trends: action.data.trends
      };
    }
    case SET_DATE_RANGE_LOADING: {
      return { ...state, dateRangeLoading: action.isLoading };
    }
    default:
      return state;
  }
};

export default PortfolioReducer;
